import { Link } from 'react-router-dom';
import { shows } from '@/mocks/shows';

export default function HotShows() {
  const hot = [...shows].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="热播排行">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热播排行
            </h2>
            <p className="mt-1 text-sm text-foreground-500">高口碑综艺排行，发现你的下一部心头好</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {hot.map((show, index) => (
            <Link
              key={show.id}
              to={`/article/${show.id}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative flex-shrink-0">
                <span className={`absolute -top-2 -left-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-background-50 ${
                  index < 3 ? 'bg-accent-500' : 'bg-foreground-400'
                }`}>
                  {index + 1}
                </span>
                <div className="w-16 h-20 md:w-20 md:h-24 rounded-md overflow-hidden">
                  <img src={show.coverImage} alt={show.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {show.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{show.category}</p>
                <div className="mt-1.5 flex items-center gap-3">
                  <span className="text-xs text-primary-500 font-medium">{show.rating}</span>
                  <span className="text-xs text-foreground-400">{show.views}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}